import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { ListCancellationReasonsQueryParamsDTO } from "@/domain/dto/ListCancellationReasonsQueryParamsDTO";
import { CancellationReason } from "@/domain/entities/CancellationReason";
import { IUserRepository } from "@/domain/repositories/IUserRepository";
import { IListCancellationReasonsUseCase } from "@/domain/usecases/IListCancellationReasonsUseCase";

export class ListCancellationReasonsUseCase implements IListCancellationReasonsUseCase {
    repository: IUserRepository
    constructor(repository: IUserRepository) {
        this.repository = repository
    }

    execute(params: ListCancellationReasonsQueryParamsDTO): Promise<PaginatedListResponse<CancellationReason>> {
        return this.repository.listCancellationReasons(params)
    }
}
